// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { SetDraftFiltersParameter } from "@store/Framework/Store/Store/Pages/LocationFinder/Handlers/setDraftFilters";
import { SetFiltersParameter } from "@store/Framework/Store/Store/Pages/LocationFinder/Handlers/setFilters";
import LocationFinderState from "@store/Framework/Store/Store/Pages/LocationFinder/LocationFinderState";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { Draft } from "immer";

const initialState: LocationFinderState = {};

const actions = {
    "Store/Pages/LocationFinder/SetFilters": (draft: Draft<LocationFinderState>) => {
        draft.filters = mergeProps(draft.filters, draft.draftFilters);
    },
    "Store/Pages/LocationFinder/SetDraftFilters": (
        draft: Draft<LocationFinderState>,
        action: SetDraftFiltersParameter,
    ) => {
        draft.draftFilters = mergeProps(draft.draftFilters, action.filters);
    },
    "Store/Pages/LocationFinder/ResetFilters": (draft: Draft<LocationFinderState>) => {
        draft.draftFilters = initialState.draftFilters;
        draft.filters = initialState.filters;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type LocationFinderActions = Parameters<typeof reducer>[1];
export default reducer;
